var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _g2, _path153, _path154, _path155, _path156, _path157, _path158, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 229,
    viewBox: "0 0 306 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.65 200.438H0.320312V200.59H305.65V200.438Z",
    fill: "#B3CCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.086 204.596H177.539V204.749H193.086V204.596Z",
    fill: "#B3CCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.439 207.9H241.598V208.053H278.439V207.9Z",
    fill: "#B3CCE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.23 204.67H136.168V204.822H174.23V204.67Z",
    fill: "#B3CCE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.484 209.237H103.521V209.39H111.484V209.237Z",
    fill: "#B3CCE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.484 209.237H119.223V209.39H155.484V209.237Z",
    fill: "#B3CCE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8353 206.66H32.3555V206.813H55.8353V206.66Z",
    fill: "#B3CCE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.047 173.202H27.1351C26.2113 173.201 25.326 172.833 24.6734 172.179C24.0208 171.525 23.6543 170.639 23.6543 169.715V3.96391C23.6623 3.04549 24.0324 2.16733 24.6841 1.52018C25.3359 0.873023 26.2166 0.509142 27.1351 0.507568H145.047C145.972 0.507568 146.859 0.874934 147.513 1.52885C148.167 2.18276 148.534 3.06966 148.534 3.99444V169.715C148.534 170.64 148.167 171.527 147.513 172.181C146.859 172.835 145.972 173.202 145.047 173.202ZM27.1351 0.629701C26.2518 0.631319 25.4053 0.983313 24.7814 1.60842C24.1574 2.23353 23.807 3.08068 23.807 3.96391V169.715C23.807 170.599 24.1574 171.446 24.7814 172.071C25.4053 172.696 26.2518 173.048 27.1351 173.05H145.047C145.931 173.048 146.778 172.696 147.403 172.071C148.028 171.446 148.38 170.599 148.382 169.715V3.96391C148.38 3.08012 148.028 2.23298 147.403 1.60805C146.778 0.983114 145.931 0.631315 145.047 0.629701H27.1351Z",
    fill: "#B3CCE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.138 173.202H159.219C158.295 173.201 157.409 172.833 156.755 172.179C156.102 171.526 155.734 170.64 155.732 169.715V3.96391C155.742 3.04493 156.113 2.16678 156.766 1.51979C157.419 0.87281 158.3 0.509124 159.219 0.507568H277.138C278.055 0.510747 278.934 0.875338 279.585 1.52232C280.235 2.1693 280.604 3.04654 280.612 3.96391V169.715C280.612 170.638 280.247 171.523 279.595 172.177C278.944 172.83 278.06 173.199 277.138 173.202ZM159.219 0.629701C158.335 0.631315 157.488 0.983114 156.863 1.60805C156.238 2.23298 155.887 3.08012 155.885 3.96391V169.715C155.887 170.599 156.238 171.446 156.863 172.071C157.488 172.696 158.335 173.048 159.219 173.05H277.138C278.022 173.048 278.869 172.696 279.494 172.071C280.119 171.446 280.47 170.599 280.472 169.715V3.96391C280.47 3.08012 280.119 2.23298 279.494 1.60805C278.869 0.983114 278.022 0.631315 277.138 0.629701H159.219Z",
    fill: "#B3CCE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.946 17.4656H54.4609V55.6013H163.946V17.4656Z",
    fill: "#F2F9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.865 53.519V19.548L56.5447 19.548V53.519L161.865 53.519Z",
    fill: "#B2C7DC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3226 17.8931H90.2402V55.1678H92.3226V17.8931Z",
    fill: "#F2F9FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7049 53.5129H90.2402V19.5419H78.7049V53.5129Z",
    fill: "#C9DDF1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.47 53.5128H126.006V19.5418H114.47V53.5128Z",
    fill: "#C9DDF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.33 53.5128H161.865V19.5418H150.33V53.5128Z",
    fill: "#C9DDF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.094 17.8931H126.012V55.1678H128.094V17.8931Z",
    fill: "#F2F9FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0919 55.5952H54.4609L54.4609 17.4595H44.0919L44.0919 55.5952Z",
    fill: "#B2C7DC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0898 53.519H63.8906L68.3973 24.5493H87.5964L83.0898 53.519Z",
    fill: "#B3CCE5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.607 53.519H101.408L104.742 24.5493H123.942L120.607 53.519Z",
    fill: "#DCEAF8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.436 53.5189H93.9707L101.317 27.1689H118.782L111.436 53.5189Z",
    fill: "#C9DDF1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7421 22.2104H56.543V53.519H75.7421V22.2104Z",
    fill: "#DCEAF8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.656 22.2104H138.457V53.519H157.656V22.2104Z",
    fill: "#DCEAF8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.063 53.5189H129.188L134.36 27.1689H149.235L144.063 53.5189Z",
    fill: "#C9DDF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M136.655 53.5189H128.094V29.0803H144.838L136.655 53.5189Z",
    fill: "#DCEAF8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.657 22.2104H153.285V53.519H157.657V22.2104Z",
    fill: "#B3CCE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2108 51.1924C70.0585 51.1924 69.9125 51.1319 69.8049 51.0243C69.6972 50.9166 69.6368 50.7706 69.6368 50.6184V25.1294C69.6359 25.0535 69.6502 24.9782 69.6787 24.9079C69.7072 24.8375 69.7493 24.7735 69.8027 24.7196C69.8561 24.6656 69.9196 24.6228 69.9897 24.5935C70.0597 24.5643 70.1349 24.5493 70.2108 24.5493C70.2897 24.5442 70.3688 24.5555 70.4432 24.5825C70.5175 24.6094 70.5855 24.6515 70.6428 24.706C70.7001 24.7604 70.7456 24.8262 70.7763 24.899C70.8071 24.9719 70.8224 25.0503 70.8214 25.1294V50.5817C70.8268 50.6633 70.8147 50.7451 70.7859 50.8216C70.7572 50.8982 70.7124 50.9677 70.6546 51.0255C70.5967 51.0833 70.5272 51.1281 70.4507 51.1569C70.3742 51.1857 70.2924 51.1978 70.2108 51.1924Z",
    fill: "#F2F9FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M199.798 55.6013H90.3125V93.7371H199.798V55.6013Z",
    fill: "#F2F9FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M197.723 91.6547V57.6837L92.4021 57.6837V91.6547H197.723Z",
    fill: "#B2C7DC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M128.174 56.0288H126.092V93.3035H128.174V56.0288Z",
    fill: "#F2F9FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M114.556 91.6486H126.092V57.6775H114.556V91.6486Z",
    fill: "#C9DDF1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.322 91.6487H161.857V57.6776H150.322V91.6487Z",
    fill: "#C9DDF1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M186.181 91.6486H197.717V57.6775H186.181V91.6486Z",
    fill: "#C9DDF1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M163.953 56.0288H161.871V93.3035H163.953V56.0288Z",
    fill: "#F2F9FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9435 93.731H90.3125V55.5952H79.9435V93.731Z",
    fill: "#B2C7DC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M154.641 91.6487H135.441L139.954 62.679H159.147L154.641 91.6487Z",
    fill: "#B3CCE5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M192.318 91.6487H173.119L176.453 62.679H195.652L192.318 91.6487Z",
    fill: "#DCEAF8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M183.14 91.6486H165.682L173.028 65.2986H190.493L183.14 91.6486Z",
    fill: "#C9DDF1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M147.293 60.3401H128.094V91.6486H147.293V60.3401Z",
    fill: "#DCEAF8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.957 60.3401H102.758V91.6486H121.957V60.3401Z",
    fill: "#DCEAF8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.364 91.6486H93.4824L98.6547 65.2986H113.536L108.364 91.6486Z",
    fill: "#C9DDF1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M100.958 91.6486H92.3965V67.2161H109.135L100.958 91.6486Z",
    fill: "#DCEAF8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.958 60.3401H117.586V91.6486H121.958V60.3401Z",
    fill: "#B3CCE5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.768 89.3099C141.691 89.3107 141.615 89.2962 141.545 89.2674C141.474 89.2385 141.41 89.1958 141.356 89.1418C141.302 89.0877 141.259 89.0234 141.23 88.9527C141.201 88.8819 141.187 88.8061 141.188 88.7297V63.2591C141.195 63.1076 141.258 62.9643 141.366 62.8571C141.473 62.7499 141.616 62.6864 141.768 62.679C141.918 62.6878 142.06 62.752 142.166 62.8591C142.272 62.9661 142.334 63.1086 142.342 63.2591V88.7297C142.342 88.8056 142.328 88.8809 142.3 88.9513C142.271 89.0216 142.229 89.0856 142.176 89.1396C142.122 89.1935 142.059 89.2364 141.989 89.2656C141.919 89.2948 141.844 89.3099 141.768 89.3099Z",
    fill: "#F2F9FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M171.77 39.1135V46.9178C171.784 49.2184 172.705 51.4206 174.333 53.0463C175.961 54.6721 178.165 55.5901 180.465 55.6014C182.771 55.5982 184.983 54.6836 186.617 53.0571C188.252 51.4305 189.177 49.2237 189.192 46.9178V39.1135H171.77Z",
    fill: "#B3CCE5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.122 142.413H62.6816V148.758H117.122V142.413Z",
    fill: "#B2C7DC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M117.122 148.758H66.2969V190.313H117.122V148.758Z",
    fill: "#B3CCE5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117.12 190.313L239.674 190.313V148.758H117.12V190.313Z",
    fill: "#DCEAF8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2953 151.109L239.674 151.109V148.764L66.2953 148.764V151.109Z",
    fill: "#C9DDF1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M117.121 148.758L243.289 148.758V142.413L117.121 142.413V148.758Z",
    fill: "#F2F9FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2969 190.313V200.438L76.4216 190.313H66.2969Z",
    fill: "#B3CCE5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M117.121 190.313V200.438L127.246 190.313H117.121Z",
    fill: "#DCEAF8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M239.674 190.313V200.438L229.549 190.313H239.674Z",
    fill: "#DCEAF8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M117.121 190.313V200.438L106.996 190.313H117.121Z",
    fill: "#B3CCE5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M188.849 190.313V200.438L178.725 190.313H188.849Z",
    fill: "#C9DDF1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M188.85 190.313V200.438L198.974 190.313H188.85Z",
    fill: "#C9DDF1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M149.988 119.91L146.293 140.874H130.312L129.744 142.413H146.018H155.972H183.006L186.975 119.91H149.988Z",
    fill: "#C9DDF1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M260.615 29.575H217.404V101.022H260.615V29.575Z",
    fill: "#C9DDF1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M261.939 29.575H218.729V101.022H261.939V29.575Z",
    fill: "#F2F9FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M240.469 80.1132H236.609L240.194 50.4901H244.053L240.469 80.1132Z",
    fill: "#B3CCE5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M250.678 80.1132H246.818L250.403 50.4901H254.262L250.678 80.1132Z",
    fill: "#B3CCE5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M230.264 80.1132H226.404L229.989 50.4901H233.848L230.264 80.1132Z",
    fill: "#B3CCE5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M152.985 228.015C218.376 228.015 271.386 224.92 271.386 221.102C271.386 217.285 218.376 214.19 152.985 214.19C87.5939 214.19 34.584 217.285 34.584 221.102C34.584 224.92 87.5939 228.015 152.985 228.015Z",
    fill: "#DCEAF8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0527 215.393H95.5899L95.7853 204.883H91.2481L91.0527 215.393Z",
    fill: "#B55B52"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8164 215.393H68.3536L70.3749 204.883H65.8377L63.8164 215.393Z",
    fill: "#B55B52"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6594 214.849H63.5665C63.4776 214.848 63.3909 214.877 63.3217 214.933C63.2525 214.989 63.2051 215.067 63.1879 215.155L62.388 219.191C62.3699 219.291 62.3741 219.393 62.4003 219.49C62.4265 219.588 62.474 219.679 62.5394 219.756C62.6048 219.833 62.6865 219.895 62.7786 219.936C62.8706 219.978 62.9708 219.999 63.0719 219.997C64.8489 219.997 65.71 219.863 67.9572 219.863C69.3373 219.863 72.183 220.003 74.0638 220.003C75.9446 220.003 76.1706 218.122 75.3828 217.951C71.8715 217.188 70.4975 216.119 69.3861 215.124C69.1832 214.951 68.9262 214.854 68.6594 214.849Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5476 214.849H90.5951C90.5062 214.848 90.4195 214.877 90.3503 214.933C90.2811 214.989 90.2337 215.067 90.2165 215.155L89.4165 219.191C89.3975 219.29 89.4007 219.391 89.4257 219.488C89.4508 219.586 89.4971 219.676 89.5614 219.753C89.6257 219.83 89.7063 219.892 89.7974 219.934C89.8885 219.977 89.9879 219.998 90.0883 219.997C91.8775 219.997 94.4545 219.863 96.7017 219.863C99.3276 219.863 99.6024 220.003 102.686 220.003C104.549 220.003 105.019 218.122 104.231 217.951C100.665 217.176 99.7611 217.09 96.6468 215.203C96.3204 214.986 95.9397 214.863 95.5476 214.849Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3613 71.8998L100.553 69.9152C100.553 69.9152 106.947 84.7298 109.103 85.6519C112.022 86.8732 116.095 90.8608 118.983 93.2729C119.081 94.0362 118.721 96.0453 118.269 96.5705C113.041 95.3492 106.538 92.3569 104.401 90.3845C99.5336 85.8839 94.3613 71.8998 94.3613 71.8998Z",
    fill: "#B55B52"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9211 68.4924C91.1807 72.4617 98.1666 85.0657 98.1666 85.0657L107.424 80.7911C106.284 76.9494 104.747 73.2369 102.838 69.7137C99.9253 64.6269 94.8324 64.1323 92.9211 68.4924Z",
    fill: "url(#paint0_linear_1604_18036)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.63 77.9576C99.6083 75.1669 96.3291 74.3791 93.4102 74.2325C94.9246 79.2216 98.1733 85.0657 98.1733 85.0657L103.456 82.623C103.279 80.9316 102.648 79.3195 101.63 77.9576Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M118.361 92.8333L123.753 93.6943L122.361 99.3917C120.472 98.5844 118.717 97.493 117.158 96.1552L118.361 92.8333Z",
    fill: "#B55B52"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M128.431 96.1063L126.459 99.2451L122.361 99.3917L123.754 93.6942L128.431 96.1063Z",
    fill: "#B55B52"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.7856 204.889L95.6817 210.306H91.1445L91.2483 204.889H95.7856Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.8313 204.889H70.3746L69.3304 210.306H64.7871L65.8313 204.889Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8515 65.9153C98.8515 65.9153 103.871 80.1437 100.073 107.019H75.8113C75.5548 103.294 77.4478 83.2337 73.4297 65.6833C76.1074 65.1638 78.8165 64.8211 81.5393 64.6574C84.9744 64.4588 88.4182 64.4588 91.8533 64.6574C94.2147 64.8975 96.5543 65.318 98.8515 65.9153Z",
    fill: "url(#paint1_linear_1604_18036)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.9191 82.6535H80.9088L80.75 78.2384H87.7604L87.9191 82.6535Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M88.084 82.4764H81.0736L80.75 78.2384H87.7604L88.084 82.4764Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4683 80.8581H81.557L81.4043 78.9407H83.3218L83.4683 80.8581Z",
    fill: "url(#paint2_linear_1604_18036)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3633 79.869H83.9192L83.8887 79.4904H87.3328L87.3633 79.869Z",
    fill: "#C9DDF1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6972 80.614H83.9798L83.9492 80.2292H86.6667L86.6972 80.614Z",
    fill: "#C9DDF1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5357 81.707H81.6182L81.5938 81.3223H83.5051L83.5357 81.707Z",
    fill: "#C9DDF1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0596 81.707H87.5037L87.4732 81.3223H84.0352L84.0596 81.707Z",
    fill: "#C9DDF1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3224 79.0262C84.2216 79.025 84.125 78.986 84.0515 78.9171C83.9781 78.8481 83.9331 78.7542 83.9255 78.6537L83.8583 77.8171C83.855 77.7699 83.8613 77.7225 83.8769 77.6778C83.8925 77.6331 83.9171 77.5921 83.9491 77.5572C83.9811 77.5224 84.0199 77.4944 84.0631 77.475C84.1062 77.4556 84.1529 77.4453 84.2003 77.4446C84.301 77.4458 84.3976 77.4847 84.4711 77.5537C84.5446 77.6226 84.5896 77.7166 84.5972 77.8171L84.6644 78.6537C84.6696 78.7013 84.6646 78.7495 84.6497 78.795C84.6348 78.8405 84.6103 78.8823 84.5779 78.9176C84.5455 78.9528 84.506 78.9808 84.4619 78.9995C84.4178 79.0183 84.3703 79.0274 84.3224 79.0262Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.8018 70.019C79.2782 72.9074 78.5393 79.7896 75.9806 87.8014C75.8568 80.9601 75.1293 74.1431 73.8066 67.4298V67.3932C75.431 67.2344 78.35 67.3077 78.8018 70.019Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6368 55.009C83.3696 58.331 83.7909 62.4408 81.5254 64.6575C81.5254 64.6575 82.9421 68.0222 89.1098 68.0222C94.7401 68.0222 91.8394 64.6575 91.8394 64.6575C88.1144 63.772 88.1755 59.1982 88.7861 56.6212L82.6368 55.009Z",
    fill: "#B55B52"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1042 67.4298L90.8812 69.4022L90.4294 70.7823C90.3932 70.8928 90.3241 70.9894 90.2312 71.0593C90.1384 71.1292 90.0264 71.1689 89.9103 71.1732L88.689 71.2342C88.589 71.2367 88.49 71.2147 88.4005 71.1699C88.3111 71.1252 88.234 71.0592 88.176 70.9777L87.2051 69.5488L89.1042 67.4298Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1053 67.4298C88.333 68.6536 87.6493 69.9311 87.0596 71.2526C87.0596 71.2526 79.6584 68.6328 79.9271 64.6452C80.7292 64.257 81.5026 63.8121 82.2415 63.314C82.2415 63.314 82.5651 65.8482 89.1053 67.4298Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1035 67.4298C90.0284 68.499 90.8011 69.6909 91.3996 70.9716C92.2233 70.1696 92.8079 69.1545 93.0883 68.0395C93.3686 66.9246 93.3337 65.7537 92.9873 64.6574C92.3409 64.4015 91.6753 64.1973 90.9966 64.0468C90.9966 64.0468 91.5156 66.5749 89.1035 67.4298Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7711 70.5014C89.9543 70.4281 92.9892 85.9083 93.435 89.7005C94.3205 94.7507 91.945 100.326 91.9389 100.314C90.7062 96.8065 89.9724 93.1434 89.7589 89.4318C89.4108 82.9833 89.2581 74.2203 88.6719 70.5014H89.7711Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.7809 56.6212C88.3261 58.4163 88.3811 60.3027 88.9397 62.0683C88.3622 61.9816 87.8006 61.8108 87.2726 61.5614C85.1658 60.5783 84.0972 59.0333 82.998 56.7311C82.9003 56.1204 82.7842 55.5708 82.6621 55.009L88.7809 56.6212Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0879 44.9514L91.7672 50.3435C92.1534 49.9222 92.4223 49.4068 92.5471 48.849C92.6718 48.2912 92.648 47.7103 92.478 47.1646C92.3081 46.6188 91.9979 46.1272 91.5785 45.7389C91.1591 45.3505 90.6451 45.079 90.0879 44.9514Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8456 50.9664C81.1524 55.3143 81.6776 57.9279 84.4438 59.7111C88.5597 62.3919 93.4572 59.2042 93.4511 54.5754C93.4511 50.4107 91.3077 43.9988 86.6239 43.1683C85.5982 42.9803 84.5412 43.0628 83.557 43.4076C82.5728 43.7524 81.6955 44.3477 81.0113 45.1347C80.3272 45.9218 79.8599 46.8735 79.6555 47.8961C79.4511 48.9186 79.5166 49.9768 79.8456 50.9664Z",
    fill: "#B55B52"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6118 54.2456C82.8331 53.4518 83.34 49.3603 82.2225 47.9314C86.1368 47.7543 88.0726 46.4292 88.1764 45.7147C89.5504 46.3253 92.9823 46.5574 92.5487 44.8231C92.3498 44.1273 91.9571 43.5024 91.4165 43.0212C90.8759 42.5401 90.2096 42.2225 89.4954 42.1057C88.1459 40.6767 84.7628 39.4798 82.3751 41.4156C78.1982 41.4156 75.9876 44.7743 77.154 46.0994C76.6612 46.388 76.2525 46.8006 75.9686 47.296C75.6846 47.7915 75.5352 48.3526 75.5352 48.9237C75.5352 49.4948 75.6846 50.0559 75.9686 50.5514C76.2525 51.0468 76.6612 51.4594 77.154 51.748C76.0426 53.4334 80.8729 57.189 81.6118 54.2456Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0275 56.2547C79.4265 56.66 79.9016 56.9825 80.4256 57.2036C80.9496 57.4247 81.5121 57.5401 82.0808 57.5432C83.5769 57.5432 83.9128 56.1082 83.125 54.8991C82.4289 53.806 80.8106 52.4869 79.461 53.0671C78.1115 53.6472 78.0443 55.2471 79.0275 56.2547Z",
    fill: "#B55B52"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M84.127 107.019C84.127 107.019 84.6094 112.722 85.2261 120.453C85.9223 129.216 86.7833 140.605 87.3024 149.258C87.3024 149.307 87.3024 149.344 87.3024 149.38C87.4001 151.023 87.4856 152.568 87.5528 153.979C88.2428 168.115 89.6595 209.256 89.6595 209.256H97.3416C97.3416 209.256 101.213 167.273 101.372 152.886C101.531 139.048 100.071 107.019 100.071 107.019H84.127Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0981 206.911C89.0614 206.911 89.1591 209.42 89.1591 209.42H98.0259L98.3251 206.599L89.0981 206.911Z",
    fill: "url(#paint3_linear_1604_18036)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.2031 120.453C85.8993 129.216 86.7603 140.605 87.2794 149.258C87.2794 149.307 87.2794 149.344 87.2794 149.38C89.1602 141.161 89.9174 130.938 89.6548 114.109L85.2031 120.453Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4665 107.019C91.4665 107.019 87.1918 139.799 84.6637 152.818C81.9157 167.041 71.4185 209.286 71.4185 209.286H63.1074C63.1074 209.286 69.6659 168.189 71.0826 154.107C72.6276 138.84 75.8091 107.049 75.8091 107.049L91.4665 107.019Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0534 207.088L62.6992 209.408H71.8286L72.5736 206.746L63.0534 207.088Z",
    fill: "url(#paint4_linear_1604_18036)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7417 50.7588C86.8272 51.1191 87.0837 51.3695 87.3157 51.3206C87.5478 51.2717 87.6699 50.9359 87.5844 50.5817C87.4989 50.2275 87.2424 49.971 87.0104 50.0199C86.7783 50.0687 86.6623 50.4046 86.7417 50.7588Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7538 49.8916C90.8393 50.2458 91.0958 50.5023 91.3278 50.4473C91.5599 50.3923 91.6759 50.0687 91.5965 49.7084C91.5171 49.3481 91.2545 49.0977 91.0225 49.1466C90.7904 49.1954 90.6988 49.5313 90.7538 49.8916Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5195 50.3435C90.2091 51.3504 91.0306 52.2603 91.9622 53.0487C91.7602 53.2762 91.5103 53.4561 91.2305 53.5754C90.9507 53.6947 90.6479 53.7505 90.3439 53.7388L89.5195 50.3435Z",
    fill: "#A02724"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6534 55.1311C89.6806 55.1226 89.7036 55.1039 89.7172 55.0788C89.7309 55.0537 89.7343 55.0243 89.7267 54.9968C89.7231 54.9835 89.717 54.9711 89.7086 54.9602C89.7002 54.9493 89.6898 54.9402 89.6778 54.9333C89.6659 54.9265 89.6528 54.9222 89.6391 54.9205C89.6255 54.9188 89.6116 54.9198 89.5984 54.9235C89.1576 55.04 88.6957 55.0522 88.2494 54.9589C87.8031 54.8656 87.3847 54.6695 87.0275 54.3861C87.0178 54.3756 87.006 54.3671 86.9929 54.3614C86.9797 54.3556 86.9656 54.3527 86.9512 54.3527C86.9369 54.3527 86.9227 54.3556 86.9095 54.3614C86.8964 54.3671 86.8846 54.3756 86.8749 54.3861C86.8645 54.3953 86.8561 54.4066 86.8504 54.4192C86.8447 54.4318 86.8418 54.4455 86.8418 54.4594C86.8418 54.4733 86.8447 54.487 86.8504 54.4996C86.8561 54.5122 86.8645 54.5235 86.8749 54.5327C87.2563 54.8475 87.7077 55.0662 88.1912 55.1703C88.6747 55.2745 89.1762 55.261 89.6534 55.1311Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2018 49.7145C85.2334 49.7075 85.263 49.6935 85.2884 49.6734C85.3138 49.6533 85.3343 49.6277 85.3483 49.5985C85.448 49.3508 85.6062 49.1309 85.8093 48.9576C86.0124 48.7842 86.2544 48.6626 86.5147 48.6031C86.5705 48.5941 86.6205 48.5633 86.6537 48.5176C86.6869 48.4718 86.7006 48.4147 86.6918 48.3588C86.6827 48.3026 86.6522 48.2521 86.6067 48.2179C86.5611 48.1837 86.504 48.1686 86.4475 48.1756C86.1178 48.2407 85.8092 48.3862 85.5492 48.5993C85.2893 48.8124 85.086 49.0864 84.9575 49.397C84.9347 49.4497 84.9334 49.5092 84.954 49.5629C84.9745 49.6165 85.0153 49.66 85.0674 49.684C85.1074 49.7091 85.1548 49.7199 85.2018 49.7145Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2123 48.0597C92.2449 48.0518 92.2745 48.0349 92.2978 48.0108C92.3179 47.9915 92.334 47.9682 92.3449 47.9425C92.3558 47.9168 92.3615 47.8892 92.3615 47.8612C92.3615 47.8333 92.3558 47.8056 92.3449 47.7799C92.334 47.7542 92.3179 47.731 92.2978 47.7116C92.0747 47.4491 91.7919 47.244 91.4732 47.1133C91.1544 46.9826 90.809 46.9302 90.4658 46.9605C90.4378 46.9642 90.4109 46.9735 90.3866 46.9879C90.3623 47.0024 90.3413 47.0216 90.3247 47.0445C90.3081 47.0674 90.2964 47.0934 90.2902 47.1209C90.284 47.1485 90.2835 47.177 90.2887 47.2048C90.2925 47.233 90.3018 47.2601 90.3162 47.2847C90.3305 47.3092 90.3496 47.3306 90.3724 47.3477C90.3951 47.3647 90.4211 47.3771 90.4486 47.384C90.4762 47.3909 90.5049 47.3923 90.533 47.388C90.8045 47.3677 91.0769 47.4125 91.3276 47.5187C91.5782 47.6249 91.7999 47.7895 91.9742 47.9986C92.0032 48.0314 92.0415 48.0547 92.0839 48.0656C92.1263 48.0764 92.171 48.0744 92.2123 48.0597Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6925 70.8373L76.7991 73.3654C76.7991 73.3654 72.2924 86.3725 71.9627 88.4426C74.4359 89.3586 77.1533 93.0409 80.4509 95.4469C80.3654 96.1919 78.9364 98.0239 78.3624 98.4208C73.4405 96.0331 65.8927 92.7295 65.5385 89.8716C64.6714 83.4596 70.6925 70.8373 70.6925 70.8373Z",
    fill: "#B55B52"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9795 95.1599H84.0907L82.6312 100.192C82.6312 100.192 79.4741 100.002 77.6055 97.688L78.9795 95.1599Z",
    fill: "#B55B52"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1497 96.1675L85.5987 100.656L82.6309 100.228L84.0903 95.1965L87.1497 96.1675Z",
    fill: "#B55B52"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4298 65.6832C69.1551 66.2939 64.5996 81.1818 64.5996 81.1818L74.4496 84.9129C76.3236 81.3631 77.9557 77.6908 79.3348 73.9211C81.2828 68.4434 78.0158 65.0115 73.4298 65.6832Z",
    fill: "url(#paint5_linear_1604_18036)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1807 215.655C70.487 215.681 70.7929 215.601 71.0478 215.429C71.1297 215.36 71.1921 215.271 71.2285 215.17C71.2649 215.069 71.2742 214.961 71.2555 214.855C71.2549 214.793 71.2369 214.732 71.2034 214.679C71.17 214.626 71.1224 214.583 71.0661 214.556C70.5654 214.3 69.1181 215.197 68.9533 215.301C68.9347 215.312 68.92 215.329 68.9113 215.348C68.9025 215.368 68.9001 215.39 68.9044 215.411C68.911 215.431 68.9221 215.449 68.937 215.464C68.9518 215.479 68.97 215.49 68.9899 215.497C69.3799 215.592 69.7792 215.646 70.1807 215.655ZM70.8341 214.721C70.8803 214.711 70.9283 214.711 70.9745 214.721C70.9959 214.735 71.0133 214.754 71.0251 214.776C71.0368 214.799 71.0426 214.824 71.0417 214.849C71.0542 214.92 71.0484 214.994 71.0249 215.062C71.0014 215.13 70.961 215.192 70.9074 215.24C70.3993 215.469 69.8233 215.498 69.2952 215.319C69.7635 215.02 70.2866 214.817 70.8341 214.721Z",
    fill: "url(#paint6_linear_1604_18036)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0137 215.497C69.0294 215.503 69.0468 215.503 69.0625 215.497C69.5266 215.24 70.4121 214.275 70.2838 213.744C70.266 213.665 70.2219 213.594 70.1587 213.543C70.0955 213.492 70.017 213.464 69.9358 213.463C69.8552 213.451 69.773 213.457 69.6949 213.48C69.6168 213.503 69.5448 213.543 69.4839 213.597C68.9648 214.031 68.8732 215.338 68.8732 215.393C68.8721 215.413 68.8766 215.432 68.8864 215.45C68.8961 215.467 68.9106 215.481 68.9282 215.49C68.9406 215.499 68.9551 215.504 68.9701 215.505C68.9851 215.506 69.0001 215.503 69.0137 215.497ZM69.8869 213.665H69.9358C70.0762 213.665 70.0884 213.744 70.0945 213.768C70.1556 214.068 69.5999 214.819 69.1419 215.173C69.159 214.659 69.3338 214.162 69.6426 213.75C69.7101 213.691 69.797 213.658 69.8869 213.658V213.665Z",
    fill: "url(#paint7_linear_1604_18036)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4523 215.655C97.8392 215.691 98.2269 215.594 98.5514 215.381C98.6214 215.314 98.6745 215.231 98.7063 215.14C98.7382 215.049 98.7479 214.951 98.7346 214.855C98.7312 214.796 98.7126 214.738 98.6805 214.688C98.6485 214.638 98.604 214.596 98.5514 214.568C97.9957 214.263 96.1943 215.179 95.9928 215.295C95.9724 215.304 95.9559 215.32 95.9459 215.34C95.9359 215.36 95.933 215.383 95.9378 215.405C95.9411 215.427 95.951 215.448 95.9662 215.464C95.9815 215.48 96.0014 215.492 96.0233 215.497C96.4939 215.592 96.9722 215.645 97.4523 215.655ZM98.2522 214.721C98.3213 214.718 98.3902 214.73 98.4537 214.758C98.4741 214.769 98.491 214.786 98.5028 214.807C98.5146 214.827 98.5209 214.85 98.5209 214.874C98.5315 214.937 98.5265 215.001 98.5063 215.062C98.4861 215.123 98.4512 215.178 98.4049 215.222C98.1301 215.466 97.3851 215.509 96.3775 215.344C96.9624 215.031 97.5964 214.82 98.2522 214.721Z",
    fill: "url(#paint8_linear_1604_18036)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0404 215.497H96.0892C96.6266 215.246 97.6891 214.275 97.5914 213.756C97.5914 213.634 97.4815 213.481 97.1884 213.457C97.0794 213.44 96.9678 213.447 96.8621 213.479C96.7564 213.511 96.6592 213.566 96.5777 213.64C96.0098 214.11 95.9182 215.332 95.9121 215.387C95.9126 215.406 95.9172 215.424 95.9256 215.441C95.9341 215.458 95.9461 215.473 95.961 215.484C95.9851 215.498 96.0133 215.502 96.0404 215.497ZM97.1029 213.665H97.1701C97.3655 213.665 97.3777 213.756 97.3838 213.781C97.4388 214.092 96.7182 214.862 96.1625 215.197C96.1994 214.683 96.3982 214.194 96.7304 213.799C96.8333 213.708 96.9658 213.658 97.1029 213.659V213.665Z",
    fill: "url(#paint9_linear_1604_18036)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M175.672 52.2428H172.82V52.8535H175.672V52.2428Z",
    fill: "url(#paint10_linear_1604_18036)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M170.279 52.2428H158.523V52.8535H170.279V52.2428Z",
    fill: "url(#paint11_linear_1604_18036)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M195.347 161.496H121.512C119.884 161.467 118.325 160.835 117.136 159.723C115.947 158.611 115.213 157.097 115.076 155.475L108.542 60.4013C108.479 59.6297 108.578 58.8535 108.832 58.1223C109.086 57.391 109.489 56.7207 110.017 56.1541C110.544 55.5876 111.184 55.1372 111.895 54.8318C112.606 54.5263 113.374 54.3725 114.148 54.3802H187.976C189.605 54.4064 191.166 55.0372 192.355 56.15C193.545 57.2627 194.278 58.778 194.413 60.4013L200.947 155.475C201.012 156.246 200.914 157.023 200.662 157.755C200.409 158.486 200.006 159.157 199.479 159.724C198.951 160.291 198.311 160.741 197.6 161.046C196.889 161.352 196.121 161.505 195.347 161.496Z",
    fill: "url(#paint12_linear_1604_18036)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M121.371 159.487C120.288 159.468 119.251 159.046 118.461 158.305C117.671 157.564 117.185 156.555 117.097 155.475L110.544 60.4012C110.501 59.8866 110.566 59.3685 110.734 58.8804C110.903 58.3923 111.172 57.9449 111.524 57.5671C111.876 57.1892 112.303 56.8891 112.778 56.6863C113.253 56.4834 113.765 56.3822 114.282 56.3891H188.117C189.199 56.4097 190.236 56.8314 191.026 57.5726C191.816 58.3138 192.302 59.3218 192.391 60.4012L198.931 155.475C198.975 155.989 198.91 156.508 198.741 156.996C198.573 157.484 198.304 157.931 197.952 158.309C197.6 158.687 197.172 158.987 196.698 159.19C196.223 159.393 195.71 159.494 195.194 159.487H121.371Z",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.158 103.453H124.028L121.506 66.697H188.63L191.158 103.453ZM124.498 102.952H190.62L188.178 67.1978H122.037L124.498 102.952Z",
    fill: "url(#paint13_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.771 72.3761H122.148L122.111 71.8754H188.734L188.771 72.3761Z",
    fill: "url(#paint14_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.124 77.5546H122.501L122.465 77.0538H189.094L189.124 77.5546Z",
    fill: "url(#paint15_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.486 82.739H122.857L122.82 82.2322H189.449L189.486 82.739Z",
    fill: "url(#paint16_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.839 87.9174H123.216L123.18 87.4105H189.803L189.839 87.9174Z",
    fill: "url(#paint17_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.195 93.0958H123.572L123.535 92.5951H190.164L190.195 93.0958Z",
    fill: "url(#paint18_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.554 98.2742H123.925L123.889 97.7734H190.518L190.554 98.2742Z",
    fill: "url(#paint19_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.548 69.787H115.394L115.357 69.2863H120.511L120.548 69.787Z",
    fill: "url(#paint20_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.902 74.9653H115.748L115.711 74.4646H120.871L120.902 74.9653Z",
    fill: "url(#paint21_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.257 80.1438H116.103L116.072 79.6431H121.226L121.257 80.1438Z",
    fill: "url(#paint22_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.616 85.3283H116.462L116.426 84.8214H121.58L121.616 85.3283Z",
    fill: "url(#paint23_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.97 90.5066H116.816L116.779 90.0059H121.939L121.97 90.5066Z",
    fill: "url(#paint24_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.325 95.6851H117.171L117.141 95.1843H122.295L122.325 95.6851Z",
    fill: "url(#paint25_linear_1604_18036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.685 100.863H117.531L117.494 100.363H122.648L122.685 100.863Z",
    fill: "url(#paint26_linear_1604_18036)"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M124.406 103.416L124.125 102.983L132.07 98.1767L134.531 95.7157L139.953 90.9342L145.565 93.0288L151.251 83.5391L159.097 85.597L169.167 78.9531L174.205 81.0782L187.414 74.4891L187.664 74.941L174.254 81.6278L169.247 79.521L159.214 86.1405L151.513 84.1131L145.803 93.6456L140.088 91.5082L134.885 96.0943L132.375 98.598L124.406 103.416Z",
    fill: "#C9DDF1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M124.455 103.373L124.07 103.031L131.746 94.3051L133.939 89.3343L141.328 93.5906L144.643 85.4872L151.061 79.5882L159.232 84.1926L168.887 74.996L175.775 79.0936L186.932 68.3521L187.292 68.7246L175.873 79.7164L168.984 75.6189L159.336 84.8154L151.159 80.205L145.034 85.8291L141.596 94.3051L134.189 90.0427L132.162 94.6227L124.455 103.373Z",
    fill: "url(#paint27_linear_1604_18036)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M144.436 129.797L149.931 111.233C153.845 112.626 157.273 115.118 159.805 118.411C162.338 121.704 163.867 125.657 164.209 129.797C164.587 134.325 163.26 138.831 160.488 142.432C157.715 146.032 153.698 148.467 149.223 149.258L144.436 129.797Z",
    fill: "#C9DDF1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M144.436 129.797L149.205 149.258C148.078 149.456 146.936 149.557 145.792 149.558C134.959 149.558 125.426 140.636 124.681 129.797C124.482 127.267 124.811 124.723 125.647 122.327C126.483 119.931 127.808 117.735 129.537 115.877C131.266 114.02 133.362 112.542 135.693 111.538C138.023 110.533 140.537 110.024 143.074 110.042C145.405 110.046 147.719 110.448 149.914 111.233L144.436 129.797Z",
    fill: "url(#paint28_linear_1604_18036)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M177.741 128.166H171.879L173.351 149.558H179.213L177.741 128.166Z",
    fill: "#C9DDF1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M177.742 128.166H171.88L170.982 115.129H176.845L177.742 128.166Z",
    fill: "url(#paint29_linear_1604_18036)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M187.983 132.062H182.121L183.324 149.558H189.186L187.983 132.062Z",
    fill: "#C9DDF1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M187.982 132.062H182.12L181.57 124.044H187.433L187.982 132.062Z",
    fill: "url(#paint30_linear_1604_18036)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M221.605 63.4482C220.994 66.4405 220.432 71.9303 222.527 73.9272C220.831 76.6777 218.302 78.8166 215.309 80.0338C211.303 77.524 213.22 73.9272 213.22 73.9272C216.561 73.1272 216.475 70.654 215.889 68.3274L221.605 63.4482Z",
    fill: "#FF8B7B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M223.601 75.6982C225.782 74.196 225.94 71.3442 225.94 71.3442C225.94 71.3442 218.002 69.3107 213.678 70.532C212.353 71.5457 210.24 73.4326 210.24 73.4326C210.24 73.4326 210.778 74.654 213.22 75.4234C215.663 76.1928 223.601 75.6982 223.601 75.6982Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M232.828 78.0126C234.318 80.1621 235.656 82.2872 236.926 84.5405C238.224 86.7765 239.398 89.0821 240.443 91.4471C240.7 92.0578 240.962 92.6684 241.194 93.2791L241.371 93.7432L241.463 93.9752L241.506 94.0913L241.579 94.305C241.761 94.8663 241.837 95.4563 241.805 96.0454C241.737 96.9587 241.488 97.8493 241.072 98.6651C240.74 99.3389 240.343 99.979 239.888 100.576C238.228 102.695 236.236 104.53 233.989 106.011L232.328 104.069C233.881 102.296 235.266 100.38 236.462 98.3476C236.7 97.9018 236.905 97.4384 237.072 96.9614C237.198 96.6411 237.252 96.2972 237.231 95.9538C237.231 95.8622 237.195 95.8255 237.176 95.8378L237.133 95.74L237.036 95.5385L236.853 95.1294C236.608 94.592 236.327 94.0607 236.065 93.5234C235.523 92.4486 234.947 91.382 234.337 90.3235C233.726 89.2609 233.115 88.2045 232.505 87.1603C231.228 85.0779 229.897 82.965 228.578 80.9621L232.828 78.0126Z",
    fill: "#FF8B7B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M233.206 103.544L227.771 103.135L230.776 107.294C230.776 107.294 233.994 106.897 234.751 104.943L233.206 103.544Z",
    fill: "#FF8B7B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M224.242 105.492L226.954 108.839L231.582 107.135L227.772 103.135L224.242 105.492Z",
    fill: "#FF8B7B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M230.831 75.0081L227.375 79.7224L227.625 85.5419L233.494 90.8669C233.494 90.8669 236.504 88.7235 239.124 86.5556C235.839 79.0262 232.871 75.6187 230.831 75.0081Z",
    fill: "url(#paint31_linear_1604_18036)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M229.58 79.4781L227.748 85.6214L229.72 87.4106C229.433 83.1116 229.58 79.4781 229.58 79.4781Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M204.097 78.5988C204.018 82.2628 204.531 89.8655 207.102 105.682H227.596C227.254 97.34 226.845 92.1127 230.832 74.9898C228.094 74.4321 225.318 74.077 222.527 73.9273C219.429 73.7072 216.319 73.7072 213.221 73.9273C211.218 74.1105 209.074 74.4341 207.444 74.715C206.522 74.8724 205.683 75.3463 205.072 76.0551C204.461 76.7639 204.117 77.6634 204.097 78.5988Z",
    fill: "url(#paint32_linear_1604_18036)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.103 80.0216L204.439 85.9633C204.629 88.0762 204.91 90.6105 205.307 93.6393L208.293 91.8684C209.526 82.8795 208.103 80.0216 208.103 80.0216Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M208.702 81.6094C207.877 84.449 206.998 87.2702 206.088 90.0792C205.178 92.8883 204.256 95.7034 203.31 98.5003L203.127 99.0254L202.833 99.7094C202.636 100.13 202.414 100.537 202.168 100.931C201.688 101.686 201.127 102.386 200.495 103.019C199.301 104.202 197.931 105.193 196.434 105.956C193.608 107.373 190.543 108.253 187.396 108.552L186.975 106.03C188.305 105.622 189.608 105.131 190.877 104.558C192.124 104.01 193.318 103.348 194.443 102.579C195.507 101.885 196.463 101.04 197.283 100.07C197.659 99.6286 197.983 99.1449 198.247 98.6285C198.379 98.3887 198.493 98.1397 198.589 97.8835L198.711 97.5415L198.858 97.0163C199.615 94.1768 200.397 91.3555 201.227 88.5404C202.058 85.7252 202.864 82.9162 203.762 80.1255L208.702 81.6094Z",
    fill: "#FF8B7B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M209.325 78.8247C208.464 76.7607 205.753 75.4233 205.753 75.4233C202.84 77.3225 201.637 79.3071 199.701 88.9556C202.803 90.3479 207.42 90.3357 207.42 90.3357L209.936 83.8444C209.936 83.8444 210.192 80.8888 209.325 78.8247Z",
    fill: "url(#paint33_linear_1604_18036)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M188.025 105.761L182.932 105.682L186.174 109.657C186.174 109.657 189.362 109.046 190.003 107.074L188.025 105.761Z",
    fill: "#FF8B7B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M179.549 108.24L182.443 111.422L186.174 109.657L182.932 105.682L179.549 108.24Z",
    fill: "#FF8B7B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M210.942 57.2074C210.875 57.6043 210.6 57.8913 210.331 57.8485C210.063 57.8058 209.916 57.4394 209.99 57.0364C210.063 56.6333 210.331 56.3463 210.6 56.4257C210.869 56.5051 210.997 56.8043 210.942 57.2074Z",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M210.711 56.438L209.795 55.9922C209.795 55.9922 210.155 56.8288 210.711 56.438Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M210.772 54.6975C210.728 54.6794 210.691 54.6489 210.665 54.6098C210.639 54.5706 210.625 54.5247 210.625 54.4777C210.625 54.4306 210.639 54.3847 210.665 54.3455C210.691 54.3064 210.728 54.2759 210.772 54.2578C211.11 54.0837 211.484 53.9929 211.865 53.9929C212.245 53.9929 212.62 54.0837 212.958 54.2578C213.011 54.2918 213.049 54.3452 213.064 54.4067C213.079 54.4682 213.069 54.533 213.037 54.5876C213.022 54.6149 213.001 54.6389 212.977 54.6581C212.952 54.6773 212.924 54.6913 212.893 54.6993C212.863 54.7073 212.832 54.7091 212.801 54.7045C212.77 54.7 212.74 54.6893 212.713 54.6731C212.446 54.5354 212.15 54.4636 211.849 54.4636C211.549 54.4636 211.253 54.5354 210.985 54.6731C210.954 54.6946 210.919 54.7081 210.882 54.7123C210.844 54.7166 210.806 54.7115 210.772 54.6975Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M210.912 58.5203C210.394 59.3725 209.761 60.1492 209.031 60.8286C209.21 61.0105 209.425 61.1512 209.664 61.2409C209.902 61.3305 210.157 61.367 210.411 61.3476L210.912 58.5203Z",
    fill: "#FF5652"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M224.762 57.9523C223.589 62.8376 223.199 64.9078 220.261 66.9962C215.846 70.135 210.124 67.6069 209.819 62.5018C209.55 57.8913 211.511 50.7038 216.677 49.5985C217.815 49.3494 218.997 49.3953 220.112 49.7319C221.227 50.0684 222.238 50.6845 223.048 51.5215C223.858 52.3585 224.441 53.3886 224.741 54.5142C225.041 55.6397 225.048 56.8232 224.762 57.9523Z",
    fill: "#FF8B7B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M229.422 60.256C229.896 56.1316 226.937 52.4035 222.813 51.9292C218.688 51.4549 214.96 54.414 214.486 58.5384C214.011 62.6629 216.97 66.391 221.095 66.8653C225.219 67.3396 228.947 64.3805 229.422 60.256Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M216.83 58.1661C222.326 54.551 230.753 52.5847 228.921 46.9666C227.444 42.4416 220.684 42.2279 215.487 44.3469C208.36 47.2292 211.34 61.7751 216.83 58.1661Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M223.821 50.142C223.773 50.1423 223.726 50.1308 223.683 50.1085C223.64 50.0861 223.604 50.0536 223.577 50.0138L217.788 41.9592C217.753 41.8927 217.743 41.8158 217.76 41.7427C217.777 41.6695 217.821 41.6051 217.882 41.5612C217.943 41.5173 218.017 41.497 218.092 41.5039C218.167 41.5108 218.237 41.5446 218.289 41.5989L224.072 49.6596C224.118 49.7247 224.136 49.8052 224.124 49.884C224.111 49.9627 224.068 50.0334 224.004 50.081C223.952 50.1219 223.887 50.1435 223.821 50.142Z",
    fill: "url(#paint34_linear_1604_18036)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M227.358 52.1755C227.295 52.1752 227.233 52.1561 227.181 52.1206C227.148 52.0974 227.12 52.068 227.098 52.0339C227.077 51.9998 227.062 51.9618 227.055 51.9221C227.048 51.8824 227.049 51.8417 227.058 51.8024C227.067 51.7631 227.084 51.7259 227.108 51.6931L232.891 43.6385C232.938 43.5721 233.009 43.5271 233.089 43.5133C233.169 43.4996 233.252 43.5182 233.318 43.5652C233.384 43.6122 233.429 43.6836 233.443 43.7638C233.457 43.8439 233.438 43.9263 233.391 43.9927L227.602 52.0534C227.574 52.0917 227.537 52.1227 227.495 52.1439C227.452 52.1652 227.405 52.176 227.358 52.1755Z",
    fill: "url(#paint35_linear_1604_18036)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M230.327 60.6617C234.417 58.1195 236.072 53.386 234.023 50.089C231.974 46.792 226.997 46.18 222.906 48.7221C218.816 51.2643 217.161 55.9978 219.21 59.2948C221.259 62.5918 226.236 63.2038 230.327 60.6617Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M207.102 105.682C207.102 105.682 208.83 143.683 209.166 159.072C209.508 175.083 209.66 212.468 209.66 212.468H213.703C213.703 212.468 220.145 181.397 218.24 159.072C221.122 141.93 223.07 105.682 223.07 105.682H207.102Z",
    fill: "#FF8B7B"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M212.457 105.682C212.457 105.682 222.081 145.478 226.02 160.36C230.154 175.987 235.735 211.308 235.79 212.468H239.283C239.283 212.468 240.383 171.663 234.856 157.789C234.856 140.404 227.62 105.682 227.62 105.682H212.457Z",
    fill: "#FF8B7B"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M236.956 211.491C239.936 210.996 239.93 212.449 240.181 214.013C240.361 214.951 240.221 215.923 239.784 216.773C238.788 218.519 239.784 221.102 236.419 221.102C233.054 221.102 232.725 220.37 233.58 218.806C234.375 217.228 234.915 215.534 235.179 213.787C235.35 212.883 235.631 211.711 236.956 211.491Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M239.997 214.434C240.07 216.449 240.266 221.102 240.266 221.102H239.735C239.735 221.102 239.124 216.144 238.764 214.807L239.997 214.434Z",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M216.213 59.6805C215.838 60.5712 215.127 61.2779 214.234 61.6468C213.013 62.1292 212.305 61.0972 212.518 59.9003C212.708 58.8194 213.563 57.2745 214.814 57.305C215.087 57.3184 215.353 57.3994 215.587 57.5409C215.821 57.6824 216.016 57.8798 216.155 58.1154C216.293 58.351 216.371 58.6174 216.381 58.8906C216.392 59.1638 216.334 59.4352 216.213 59.6805Z",
    fill: "#FF8B7B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.123 157.185C209.123 157.844 209.154 158.473 209.166 159.072C209.221 161.514 209.27 164.525 209.312 167.798L218.57 165.6C218.527 163.371 218.417 161.178 218.24 159.072C218.423 157.966 218.607 156.782 218.79 155.53L209.123 157.185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.812 157.789C234.812 156.256 234.751 154.589 234.647 152.818L224.492 154.553C225.054 156.739 225.561 158.705 226.001 160.36C226.269 161.374 226.542 162.465 226.819 163.633L235.979 161.459C235.665 160.213 235.276 158.988 234.812 157.789Z",
    fill: "black"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M207.102 105.682L207.712 166.198L236.413 160.091C236.865 125.559 234.172 113.614 227.608 105.682H207.102Z",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M226.429 120.618C226.429 120.618 220.847 125.259 214.008 126.798C221.134 126.255 224.749 124.252 226.429 120.618Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M206.326 101.877C206.386 103.18 206.515 104.478 206.711 105.767C206.748 106.133 206.851 108.93 206.967 109.565C207.083 110.2 230.521 109.828 230.056 108.857C229.592 107.886 228.084 105.901 228.084 105.474C228.084 105.046 227.925 101.889 227.73 101.627C227.534 101.364 206.442 100.888 206.326 101.877Z",
    fill: "url(#paint36_linear_1604_18036)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M206.326 101.877C206.386 103.18 206.515 104.478 206.711 105.767C206.748 106.133 206.851 108.93 206.967 109.565C207.083 110.2 230.521 109.828 230.056 108.857C229.592 107.886 228.084 105.901 228.084 105.474C228.084 105.046 227.925 101.889 227.73 101.627C227.534 101.364 206.442 100.888 206.326 101.877Z",
    fill: "#263238"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M209.642 210.996C208.592 214.019 205.551 219.405 205.551 219.405L211.322 217.811L214.155 213.359L213.544 212.187L209.642 210.996Z",
    fill: "#FF8B7B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M214.406 211.851C214.652 212.367 214.769 212.935 214.747 213.506C214.711 215.576 214.479 221.078 214.479 221.078H213.996C213.999 219.385 213.913 217.694 213.74 216.01C213.496 214.642 212.903 217.054 211.987 218.409C211.071 219.765 209.276 221.005 206.113 221.078C202.412 221.17 200.916 221.005 201.991 220.107C203.066 219.209 205.502 218.635 205.502 218.635C206.507 218.609 207.486 218.319 208.344 217.795C209.201 217.271 209.906 216.531 210.387 215.649C211.487 213.665 212.83 211.692 213.74 211.228C213.892 211.273 214.031 211.352 214.147 211.461C214.262 211.569 214.351 211.702 214.406 211.851Z",
    fill: "#263238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1604_18036",
    x1: 100.033,
    y1: 65.5312,
    x2: 100.033,
    y2: 85.0657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1604_18036",
    x1: 87.4616,
    y1: 64.5084,
    x2: 87.4616,
    y2: 107.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1604_18036",
    x1: 82.4363,
    y1: 78.9407,
    x2: 82.4363,
    y2: 80.8581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1604_18036",
    x1: 93.7075,
    y1: 206.599,
    x2: 93.7075,
    y2: 209.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1604_18036",
    x1: 67.6364,
    y1: 206.746,
    x2: 67.6364,
    y2: 209.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1604_18036",
    x1: 72.2543,
    y1: 65.5996,
    x2: 72.2543,
    y2: 84.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1604_18036",
    x1: 70.0836,
    y1: 214.51,
    x2: 70.0836,
    y2: 215.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1604_18036",
    x1: 69.5847,
    y1: 213.457,
    x2: 69.5847,
    y2: 215.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1604_18036",
    x1: 97.338,
    y1: 214.506,
    x2: 97.338,
    y2: 215.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1604_18036",
    x1: 96.7549,
    y1: 213.448,
    x2: 96.7549,
    y2: 215.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1604_18036",
    x1: 174.246,
    y1: 52.2428,
    x2: 174.246,
    y2: 52.8535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1604_18036",
    x1: 164.401,
    y1: 52.2428,
    x2: 164.401,
    y2: 52.8535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1604_18036",
    x1: 154.745,
    y1: 54.3799,
    x2: 154.745,
    y2: 161.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1604_18036",
    x1: 156.332,
    y1: 66.697,
    x2: 156.332,
    y2: 103.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1604_18036",
    x1: 155.441,
    y1: 71.8754,
    x2: 155.441,
    y2: 72.3761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1604_18036",
    x1: 155.795,
    y1: 77.0538,
    x2: 155.795,
    y2: 77.5546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1604_18036",
    x1: 156.153,
    y1: 82.2322,
    x2: 156.153,
    y2: 82.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1604_18036",
    x1: 156.51,
    y1: 87.4105,
    x2: 156.51,
    y2: 87.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1604_18036",
    x1: 156.865,
    y1: 92.5951,
    x2: 156.865,
    y2: 93.0958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1604_18036",
    x1: 157.222,
    y1: 97.7734,
    x2: 157.222,
    y2: 98.2742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1604_18036",
    x1: 117.953,
    y1: 69.2863,
    x2: 117.953,
    y2: 69.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1604_18036",
    x1: 118.306,
    y1: 74.4646,
    x2: 118.306,
    y2: 74.9653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1604_18036",
    x1: 118.665,
    y1: 79.6431,
    x2: 118.665,
    y2: 80.1438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1604_18036",
    x1: 119.021,
    y1: 84.8214,
    x2: 119.021,
    y2: 85.3283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1604_18036",
    x1: 119.375,
    y1: 90.0059,
    x2: 119.375,
    y2: 90.5066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1604_18036",
    x1: 119.733,
    y1: 95.1843,
    x2: 119.733,
    y2: 95.6851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1604_18036",
    x1: 120.089,
    y1: 100.363,
    x2: 120.089,
    y2: 100.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1604_18036",
    x1: 155.681,
    y1: 68.3521,
    x2: 155.681,
    y2: 103.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1604_18036",
    x1: 137.269,
    y1: 110.041,
    x2: 137.269,
    y2: 149.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1604_18036",
    x1: 174.362,
    y1: 115.129,
    x2: 174.362,
    y2: 128.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1604_18036",
    x1: 184.776,
    y1: 124.044,
    x2: 184.776,
    y2: 132.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1604_18036",
    x1: 233.25,
    y1: 75.0081,
    x2: 233.25,
    y2: 90.8669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1604_18036",
    x1: 217.461,
    y1: 73.7622,
    x2: 217.461,
    y2: 105.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1604_18036",
    x1: 204.836,
    y1: 75.4233,
    x2: 204.836,
    y2: 90.3357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1604_18036",
    x1: 220.94,
    y1: 41.5026,
    x2: 220.94,
    y2: 50.1421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1604_18036",
    x1: 230.249,
    y1: 43.5089,
    x2: 230.249,
    y2: 52.1755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1604_18036",
    x1: 218.195,
    y1: 101.279,
    x2: 218.195,
    y2: 109.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataReports);
export default __webpack_public_path__ + "static/media/Data-Reports.f90d0c171f198d9f5b9725e8d9c097e2.svg";
export { ForwardRef as ReactComponent };